module.exports = "/src/views/player/help/images/airdrop1.jpg";